import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useSpecificParams } from 'record-it-components/hooks/useSpecificParams/useSpecificParams';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { CreateConstructionSitePageContent } from '../../constructionSite/CreateConstructionSitePageContent/CreateConstructionSitePageContent';
export type ConstructionSiteAdminCreateConstructionSitePageProps = PropsWithoutChildren<Record<never, never>>;
export const ConstructionSiteAdminCreateConstructionSitePage: FunctionComponent<ConstructionSiteAdminCreateConstructionSitePageProps> = React.memo(props => {
  const $ = _c(11);
  prepareProps({
    props,
    ignoreChildren: true
  });
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      requiredParamNames: ["userGroupId"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    userGroupId
  } = useSpecificParams(t0);
  const navigate = useNavigate();
  let t1;
  if ($[1] !== userGroupId) {
    t1 = builder => builder.addHomePage().addConstructionSiteAdminPage().addConstructionSiteAdminCreateConstructionSitePage(userGroupId);
    $[1] = userGroupId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useConfigureBreadcrumbsWithBuilder(t1);
  let t2;
  if ($[3] !== navigate) {
    t2 = () => {
      navigate(RoutePaths.adminConstructionSites());
    };
    $[3] = navigate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleConstructionSiteCreated = useEventCallback(t2);
  let t3;
  if ($[5] !== navigate) {
    t3 = () => {
      navigate(RoutePaths.adminConstructionSites());
    };
    $[5] = navigate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCancel = useEventCallback(t3);
  let t4;
  if ($[7] !== handleCancel || $[8] !== handleConstructionSiteCreated || $[9] !== userGroupId) {
    t4 = <CreateConstructionSitePageContent userGroupId={userGroupId} onCancel={handleCancel} onConstructionSiteCreated={handleConstructionSiteCreated} data-testid="ConstructionSiteAdminCreateConstructionSitePage.PageContent" />;
    $[7] = handleCancel;
    $[8] = handleConstructionSiteCreated;
    $[9] = userGroupId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});